import Api from './api.service';

export default {
  get: () => Api.get('cities'),
  getId: (id) => Api.get(`cities/${id}`),
  search: (term = '') => Api.get(`cities?filter[name]=${term}`),
};
